import React from "react";
import { useDispatch } from "react-redux";

import { USER_ACTIONS } from "Bands/types";
import { DeleteUserEntityModal } from "Bands/containers";
import { copy } from "shared/assets";
import { deleteUserSocialSecurityForm } from "Bands/state";

const { userSocialSecurityForm: formCopy } = copy;

interface Props {
  id: string;
  handleClose: () => void;
}

export const DeleteUserSocialSecurityFormModal: React.FC<Props> = ({ id, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(deleteUserSocialSecurityForm(id));
  };

  return (
    <DeleteUserEntityModal
      type="social security form"
      action={USER_ACTIONS.deleteUserSocialSecurityForm}
      successMessage={formCopy.messages.deleted}
      handleDelete={handleDelete}
      handleClose={handleClose}
    />
  );
};
